import axios from "axios";
import { baseUrl } from "../util";

export const getAccountsData = ({
  filters = null,
  sortBy = null,
  setAccounts,
}) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/accounts-economic",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    params: {
      filter: filters,
      sort: sortBy,
    },
  };

  axios(config)
    .then(function (response) {
      const data = response.data.collection;
      setAccounts(data);
    })
    .catch(function (error) {
      console.log(error);
    });
};
